export const approximateRecordCountMessage =
  "The record count is approximate and is based only on records with non-null values for required fields. Filters are not applied to this count.";
